import axios from 'axios'

export default {
  getWorkSchedule (payload) {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.post('/api/work-schedule', payload, {
        headers: {
          Authorization: 'Bearer' + token
        }
      }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  },
  removeBooking (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/booking/delete/${id}`, {}, {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(() => {
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  },
  create (payload) {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.post('/api/booking/create', payload, {
        headers: {
          Authorization: 'Bearer' + token
        }
      }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  },
  edit (id, payload) {
    const token = localStorage.getItem('access_token')
    return new Promise((resolve, reject) => {
      axios.post('/api/booking/update/' + id, payload, {
        headers: {
          Authorization: 'Bearer' + token
        }
      }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  }
}
